<template>
  <div>
    <div id="takeawayproc" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="takeawayproc" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content cont">
          <div class="modal-header">
            <h5 class="modal-title">
              <span v-if="!selectedCustomer">Find Customer</span>
              <span v-else>Delivery Address</span>
            </h5>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button> -->
          </div>
          
          <div class="modal-body">
            <!-- Search Section -->
            <transition name="fade-slide" mode="out-in">
              <div v-if="!selectedCustomer" key="search" class="search-section">
                <div class="search-container">
                  <div class="search-input-group">
                    <input 
                      type="text" 
                      autocomplete="off" 
                      placeholder="Search by phone or name" 
                      id="search" 
                      v-model="searchQuery"
                      @input="filterCustomers"
                      @focus="showResults = true"
                      @blur="handleInputBlur"
                      class="form-control search-input"
                    >
                    <button class="search-icon-btn" @click="openKeypad('search')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </button>
                  </div>
                  
                  <transition name="fade-slide">
                    <div class="search-results" v-show="showResults && searchQuery">
                      <div v-if="filteredCustomers.length > 0" class="results-list">
                        <div 
                          v-for="customer in filteredCustomers" 
                          :key="customer.id" 
                          class="customer-item"
                          @mousedown.prevent="selectCustomer(customer)"
                        >
                          <div class="customer-avatar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                              <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                          </div>
                          <div class="customer-details">
                            <div class="customer-name">{{ customer.name }}</div>
                            <div class="customer-meta">
                              <span class="customer-phone">{{ customer.phone }}</span>
                              <span class="customer-area">{{ customer.area }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="no-results">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                        </svg>
                        <p>No customers found</p>
                      </div>
                    </div>
                  </transition>
                </div>
                
                <div class="divider">
                  <span>OR</span>
                </div>
                
                <button style="background-color: #52D04F !important;" class="btn btn-block add-new-btn" @mousedown.prevent="addNewCustomer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                  Add New Customer
                </button>
              </div>
              
              <!-- Address Selection Section -->
              <div v-else key="address" class="address-section">
                <div class="customer-card">
                  <div class="customer-avatar large">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div class="customer-info">
                    <h4>{{ selectedCustomer.name }}</h4>
                    <p class="text-muted">{{ selectedCustomer.phone }}</p>
                  </div>
                </div>
                
                <h6 class="section-title">Select Delivery Address</h6>
                
                <div class="address-list">
                  <div 
                    v-for="(address, index) in customerAddresses" 
                    :key="index"
                    class="address-item"
                    :class="{ 'selected': selectedAddress === address }"
                    @click="selectAddress(address)"
                  >
                    <div class="address-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <div class="address-content">
                      <div class="address-title">{{ address.title || `Address ${index + 1}` }}</div>
                      <div class="address-details">
                        <div>{{ address.area }}, {{ address.street }}</div>
                        <div>Bldg: {{ address.build }}, Floor: {{ address.floor }}, Flat: {{ address.flat }}</div>
                      </div>
                    </div>
                    <div class="address-check">
                      <svg v-if="selectedAddress === address" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
                  <!-- <div v-if="selectedAddress" class="address-confirmation">
    <div class="selected-address-preview">
      <h6>Selected Address:</h6>
      <div class="address-preview-content">
        <div>{{ selectedAddress.area }}, {{ selectedAddress.street }}</div>
        <div>Bldg: {{ selectedAddress.build }}, Floor: {{ selectedAddress.floor }}, Flat: {{ selectedAddress.flat }}</div>
      </div>
    </div>
  </div> -->
                <button class="btn btn-outline-secondary btn-block back-btn" @click="backToSearch">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                  </svg>
                  Back to Search
                </button>
              </div>
            </transition>
          </div>
          <!-- Order Details Modal -->
<div id="orderDetailsModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Order Details #{{ selectedOrder.id || 'N/A' }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeOrderDetailsModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
   <div class="order-address-details">
  <div class="detail-row">
    <span class="detail-label">Area:</span>
    <span class="detail-value">{{ selectedOrder.area || 'N/A' }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Street:</span>
    <span class="detail-value">{{ selectedOrder.street || 'N/A' }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Building:</span>
    <span class="detail-value">{{ selectedOrder.build || 'N/A' }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Floor:</span>
    <span class="detail-value">{{ selectedOrder.floor || 'N/A' }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Flat:</span>
    <span class="detail-value">{{ selectedOrder.flat || 'N/A' }}</span>
  </div>
  
  <div class="divider"></div>
  
  <div class="total-row">
    <span class="total-label">Order Total:</span>
    <span class="total-value">{{ formatCurrency(selectedOrder.grand_total) || 'N/A' }}</span>
  </div>
</div>
      <div class="modal-body">
        <div v-if="selectedOrder && Object.keys(selectedOrder).length > 0" class="order-details-container">
          <!-- Rest of your modal content -->
        </div>
        <div v-else class="text-center py-4">
          <p>No order details available</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeOrderDetailsModal">Close</button>
        <button type="button" class="btn btn-primary" @click="printOrderDetails" v-if="selectedOrder && selectedOrder.id">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-printer">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          Print
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Add this near your other modals -->
<div id="addCustomerModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Customer</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showAddCustomerModal = false">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <AddCustomerComponent 
        :fromPos="true"
          @customer-added="handleNewCustomer"
          @cancel="showAddCustomerModal = false"
        />
      </div>
    </div>
  </div>
</div>
          <div class="modal-footer">
            <button style="background-color: #E91C0C; color: #fff;" class="btn btn-link cancel-btn" data-dismiss="modal" @click="closeModal"> 
              Cancel
            </button>
            <button 
              class="btn btn-primary submit-btn" 
              @click="submitForm" 
              :disabled="!selectedCustomer || !selectedAddress || isSubmitting"
              v-if="selectedCustomer"
            >
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ isSubmitting ? 'Processing...' : 'Confirm Delivery' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="paidOrdersModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Customer's Paid Orders</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePaidOrdersModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div v-if="loadingOrders" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else>
          <div v-if="paidOrders.length > 0" class="orders-list">
            <div v-for="order in paidOrders" :key="order.id" class="order-item mb-3 p-3 border rounded">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">Order #{{ order.id }}</h6>
                <span class="badge bg-success">Paid</span>
              </div>
              <div class="order-date text-muted small mb-2">
                {{ formatDate(order.created_at) }}
              </div>
              <div class="order-items">
                <div v-for="item in order.items" :key="item.id" class="d-flex justify-content-between py-1 border-bottom">
                  <span>{{ item.quantity }} x {{ getItemName(item.itemId) }}</span>
                  <span>{{ formatCurrency(item.total) }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-2 pt-2 border-top">
                <strong>Total:</strong>
                <strong>{{ formatCurrency(order.grand_total) }}</strong>
              </div>
              <div style="display: flex; justify-content: space-between;">
              <button 
                class="btn btn-sm gr mt-2"
                @click="reorder(order.id)"
                :disabled="isReordering"
              >
                <span v-if="isReordering" class="spinner-border spinner-border-sm" role="status"></span>
                Reorder
              </button>
<button 
  class="btn btn-sm btn-primary mt-2"
  @click="showOrderDetails(order)"
  :disabled="!order"
>
  Details
</button>
              </div>
            </div>
          </div>
          <div v-else class="text-center py-4">
            <p>No paid orders found for this customer</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closePaidOrdersModal">Cancel</button>
      </div>
    </div>
  </div>
</div>
    <Keypad 
      ref="keypad"
      :target-input="$refs[inputRef]"
      @cancel="closeKeypad"
    />
       <div id="qrCodeModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delivery Location QR Code</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeQrModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div v-if="qrCodeLink" class="qr-code-container">
              <qrcode-vue :value="qrCodeLink" :size="200" level="H" />
              <div class="address-info mt-3">
                <p><strong>Customer:</strong> {{ selectedCustomer.name }}</p>
                <p><strong>Phone:</strong> {{ selectedCustomer.phone }}</p>
                <p><strong>Address:</strong> {{ selectedAddress.area }}, {{ selectedAddress.street }}</p>
                <p><strong>Building:</strong> {{ selectedAddress.build }}, Floor: {{ selectedAddress.floor }}, Flat: {{ selectedAddress.flat }}</p>
              </div>
            </div>
            <div v-else>
              <p>No location link available for this address</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeQrModal">Close</button>
            <button type="button" class="btn btn-primary" @click="printQrCode" v-if="qrCodeLink">
              Print QR Code
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Keypad from './keypad_popup_component.vue';
import QrcodeVue from 'qrcode.vue';
import $ from 'jquery';
import AddCustomerComponent from './add_customer_component.vue';
import { Modal } from 'bootstrap';

export default {
  name: 'TakeawayProcModal',
  components: {
    AddCustomerComponent,
    Keypad,
    QrcodeVue
  },
  data() {
   return {
      searchQuery: '',
      customers: [],
      filteredCustomers: [],
      selectedOrder: {},
      showAddCustomerModal: false,
      orderDetailsModal: null,
      selectedCustomer: null,
      selectedAddress: null,
      customerAddresses: [],
      keypadModal: null,
      deliveryData: {},
      loading: false,
      error: null,
      showResults: false,
      isSubmitting: false,
      inputRef: '',
      qrCodeLink: '',
      qrModal: null,
      paidOrders: [],
    paidOrdersModal: null,
    loadingOrders: false,
    isReordering: false,
    itemNames: {}
    };
  },
  async mounted() {
    $('#takeawayproc').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#takeawayproc').modal('show');
    $('#takeawayproc').on('hidden.bs.modal', () => {
      this.$emit('close');
    });
    
    this.$nextTick(() => {
      const modalElement = this.$refs.keypad.$el;
      this.keypadModal = new Modal(modalElement);
    });

    await this.fetchCustomers();
  },
  beforeUnmount() {
    $('#takeawayproc').off('hidden.bs.modal');
    $('#takeawayproc').modal('hide');
  },
  methods: {
     async showPaidOrders(customerId) {
  this.loadingOrders = true;
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${this.$BASE_API_URL}/api/orders/paid/${customerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch paid orders');
    }

    const data = await response.json();
    this.paidOrders = data.data || []; // Ensure it's always an array
    
    // Only fetch item names if we have orders with items
    if (this.paidOrders.length > 0 && this.paidOrders.some(order => order.items && order.items.length > 0)) {
      await this.fetchItemNames();
    }
    
    // Show the modal
    this.$nextTick(() => {
      const modalElement = document.getElementById('paidOrdersModal');
      this.paidOrdersModal = new Modal(modalElement);
      this.paidOrdersModal.show();
    });
  } catch (error) {
    console.error('Error fetching paid orders:', error);
    // this.$toast.error('Failed to load paid orders. Please try again.');
    this.paidOrders = []; // Reset to empty array on error
  } finally {
    this.loadingOrders = false;
  }
},
  showOrderDetails(order) {
    this.closePaidOrdersModal();
  this.selectedOrder = order || {}; 
  this.$nextTick(() => {
    const modalElement = document.getElementById('orderDetailsModal');
    if (modalElement) {
      this.orderDetailsModal = new Modal(modalElement);
      this.orderDetailsModal.show();
    }
  });
},
  
  closeOrderDetailsModal() {
    if (this.orderDetailsModal) {
      this.orderDetailsModal.hide();
    }
  },
  
  formatDateTime(dateTimeString) {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return date.toLocaleString();
  },
async fetchItemNames() {
  try {
    // Safely get all item IDs
    const itemIds = this.paidOrders
      .filter(order => order.items && Array.isArray(order.items)) 
      .flatMap(order => 
        order.items
          .filter(item => item && item.itemId) 
          .map(item => item.itemId)
      )
      .filter((itemId, index, self) => self.indexOf(itemId) === index); 

    if (itemIds.length === 0) return;

    const token = localStorage.getItem('authToken');
    const response = await fetch(`${this.$BASE_API_URL}/api/items?ids=${itemIds.join(',')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.data && Array.isArray(data.data)) {
        data.data.forEach(item => {
          if (item && item.id) {
            this.itemNames[item.id] = item.name || `Item #${item.id}`;
          }
        });
      }
    }
  } catch (error) {
    console.error('Error fetching item names:', error);
    // Fail silently - we'll just show item IDs if names aren't available
  }
},

  // async fetchItemNames() {
  //   // Get unique item IDs from all orders
  //   const itemIds = [...new Set(
  //     this.paidOrders.flatMap(order => 
  //       order.items.map(item => item.itemId)
  //     )
  //   )];

  //   if (itemIds.length === 0) return;

  //   try {
  //     const token = localStorage.getItem('authToken');
  //     const response = await fetch(`${this.$BASE_API_URL}/api/items?ids=${itemIds.join(',')}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       data.data.forEach(item => {
  //         this.itemNames[item.id] = item.name;
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching item names:', error);
  //   }
  // },

  getItemName(itemId) {
    return this.itemNames[itemId] || `Item #${itemId}`;
  },

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  },

  formatDate(dateString) {
    return new Date(dateString).toLocaleString();
  },

  async reorder(orderId) {
    this.isReordering = true;
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${this.$BASE_API_URL}/api/orders/reorder/${orderId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to reorder');
      }

      const data = await response.json();
      this.$toast.success('Order recreated successfully');
      this.closePaidOrdersModal();
      this.closeModal();
      this.$emit('reordered', data.data);
    } catch (error) {
      console.error('Error reordering:', error);
      this.$toast.error('Failed to reorder. Please try again.');
    } finally {
      this.isReordering = false;
    }
  },

  closePaidOrdersModal() {
    if (this.paidOrdersModal) {
      this.paidOrdersModal.hide();
    }
  },
  
  // Modify your selectCustomer method to show paid orders after selection
  async selectCustomer(customer) {
    this.loading = true;
    try {
      this.$root.isLoading = true;
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${this.$BASE_API_URL}/api/customers/${customer.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch customer details');
      }

      const data = await response.json();
      this.selectedCustomer = data.data;
      this.customerAddresses = data.data.addresses || [];
      
      await this.showPaidOrders(customer.id);
      
      if (this.customerAddresses.length === 1) {
        this.selectedAddress = this.customerAddresses[0];
      }
    } catch (error) {
      console.error('Error fetching customer details:', error);
      this.error = error.message;
      this.$toast.error('Failed to load customer details. Please try again.');
    } finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
  },
    async fetchCustomers() {
      this.$root.isLoading = true; 
      this.loading = true;
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/customers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch customers');
        }

        const data = await response.json();
        this.customers = data.data;
      } catch (error) {
        console.error('Error fetching customers:', error);
        this.error = error.message;
        this.$toast.error('Failed to load customers. Please try again.');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    selectAddress(address) {
      console.log(address);
      this.selectedAddress = address;
      // Scroll to bottom to show the submit button
      this.$nextTick(() => {
        const modalBody = this.$el.querySelector('.modal-body');
        modalBody.scrollTop = modalBody.scrollHeight;
      });
    },
    filterCustomers() {
      if (!this.searchQuery) {
        this.filteredCustomers = [];
        return;
      }
      
      const query = this.searchQuery.toLowerCase();
      this.filteredCustomers = this.customers.filter(customer => 
        customer.phone.toLowerCase().includes(query) ||
        customer.name.toLowerCase().includes(query)
      ).slice(0, 5); // Limit to 5 results for better UX
    },
    
    // async selectCustomer(customer) {
    //   this.loading = true;
    //   try {
    //     this.$root.isLoading = true;
    //     const token = localStorage.getItem('authToken');
    //     const response = await fetch(`${this.$BASE_API_URL}/api/customers/${customer.id}`, {
    //       method: 'GET',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });

    //     if (!response.ok) {
    //       throw new Error('Failed to fetch customer details');
    //     }

    //     const data = await response.json();
    //     this.selectedCustomer = data.data;
    //     this.customerAddresses = data.data.addresses || [];
        
    //     // Auto-select if only one address exists
    //     if (this.customerAddresses.length === 1) {
    //       this.selectedAddress = this.customerAddresses[0];
    //     }
    //   } catch (error) {
    //     console.error('Error fetching customer details:', error);
    //     this.error = error.message;
    //     this.$toast.error('Failed to load customer details. Please try again.');
    //   } finally {
    //     this.$root.isLoading = false;
    //     this.loading = false;
    //   }
    // },
    
    // selectAddress(address) {
    //   this.selectedAddress = address;
    // },
    
    backToSearch() {
      this.selectedCustomer = null;
      this.selectedAddress = null;
      this.customerAddresses = [];
      this.searchQuery = '';
      this.filteredCustomers = [];
      this.showResults = false;
    },
    
    handleInputBlur() {
      setTimeout(() => {
        this.showResults = false;
      }, 200);
    },
    
    addNewCustomer() {
  this.showAddCustomerModal = true;
  this.$nextTick(() => {
    $('#addCustomerModal').modal('show');
  });
},
handleNewCustomer(newCustomer) {
  this.customers.push(newCustomer);
  // this.selectCustomer(newCustomer);
  this.showAddCustomerModal = false;
  $('#addCustomerModal').modal('hide');
},
    
    openKeypad(inputRef) {
      this.inputRef = inputRef;
      this.$refs.keypad.setTargetInput(document.getElementById(inputRef));
      this.keypadModal.show();
    },
    
    closeKeypad() {
      if (this.keypadModal) {
        this.keypadModal.hide();
      }
      this.removeBackdrop();
    },
    
    removeBackdrop() {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.paddingRight = '';
    },
    
    closeModal() {
      $('#takeawayproc').modal('hide');
    },
    
       async submitForm() {
      if (!this.selectedCustomer || !this.selectedAddress) return;

      this.isSubmitting = true;
       console.log("customer",this.selectedCustomer.id);
      try {
        this.$root.isLoading = true; 
        this.deliveryData = {
          area: this.selectedAddress.area,
          street: this.selectedAddress.street,
          build: this.selectedAddress.build,
          floor: this.selectedAddress.floor,
          flat: this.selectedAddress.flat,
          csutomer: this.selectedCustomer.id,
          link: this.selectedAddress.link
        };
        console.log(this.deliveryData);

        // Set the QR code link if available
        this.qrCodeLink = this.selectedAddress.link || '';
        
        // Show QR code modal if there's a link
        // if (this.qrCodeLink) {
        //   this.showQrModal();
        // }
        // else{
       this.$emit('submit', this.deliveryData);
      this.closeModal();
        //}
  

      } catch (error) {
        console.error('Error creating order:', error);
        this.error = error.message;
        this.$toast.error(`Order creation failed: ${error.message}`);
      } finally {
        this.$root.isLoading = false;
        this.isSubmitting = false;
      }
    },
    
    showQrModal() {
      this.$nextTick(() => {
        const qrModalElement = document.getElementById('qrCodeModal');
        this.qrModal = new Modal(qrModalElement);
        this.qrModal.show();
      });
    },
    
    closeQrModal() {
      if (this.qrModal) {
        this.qrModal.hide();
      }
    },
    
   async printQrCode() {
  try {
    // Prepare the print content
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Delivery Location QR Code</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              text-align: center; 
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
            }
            h1 { margin-bottom: 20px; }
            .qr-container { 
              margin: 20px auto; 
              max-width: 300px; 
            }
            .address-info { 
              margin-top: 20px; 
              text-align: left; 
              padding: 15px;
              border-radius: 5px;
            }
            .address-info p { margin: 5px 0; }
            .action-buttons {
              margin-top: 20px;
            }
            button {
              padding: 8px 15px;
              margin: 0 10px;
              cursor: pointer;
            }
            .print-btn {
              background: #007bff;
              color: white;
              border: none;
              border-radius: 4px;
            }
            .close-btn {
              background: #6c757d;
              color: white;
              border: none;
              border-radius: 4px;
            }
          </style>
        </head>
        <body>
          <h1>Delivery Location</h1>
          <div class="qr-container">
            <img src="https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrCodeLink)}" 
                 alt="QR Code" width="300" height="300">
          </div>
          <div class="address-info">
            <p><strong>Customer:</strong> ${this.selectedCustomer.name}</p>
            <p><strong>Phone:</strong> ${this.selectedCustomer.phone}</p>
            <p><strong>Address:</strong> ${this.selectedAddress.area}, ${this.selectedAddress.street}</p>
            <p><strong>Building:</strong> ${this.selectedAddress.build}, Floor: ${this.selectedAddress.floor}, Flat: ${this.selectedAddress.flat}</p>
            <p><strong>Map Link:</strong> <small>${this.qrCodeLink}</small></p>
          </div>
          <div class="action-buttons">
            <button class="print-btn" onclick="window.print()">Print</button>
            <button class="close-btn" onclick="window.close()">Close</button>
          </div>
        </body>
      </html>
    `;

    // Open print window
    const printWindow = window.open('', '_blank', 'width=800,height=800');
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Close the QR modal after opening the print window
    this.closeQrModal();
    this.$emit('submit', this.deliveryData);
    this.closeModal();
    this.removeBackdrop();
    // Optional: Auto-print after a short delay
    printWindow.onload = function() {
      setTimeout(() => {
        printWindow.print();
      }, 500);
    };

  } catch (error) {
    console.error('QR printing error:', error);
    this.$toast.error('Failed to generate QR code');
  }
}
  
  }
};
</script>

<style scoped>
.qr-code-container {
  margin: 0 auto;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  max-width: 250px;
  text-align: center;
}

.address-info {
  text-align: left;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}

.address-info p {
  margin: 5px 0;
  font-size: 0.9rem;
}
.cont{
      background-color: var(--bg-color) !important;
}
.modal-content {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.25rem 1.5rem;
  /* background-color: #f8f9fa; */
  place-content: center;
}

.modal-title {
  font-weight: 600;
  font-size: 1.25rem;
}
/* Order Details Modal Styles */
.order-details-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.summary-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.summary-item {
  display: flex;
  justify-content: space-between;
}

.summary-label {
  font-weight: 500;
  color: #6c757d;
}

.summary-value {
  font-weight: 500;
}

.address-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.address-line {
  margin-bottom: 0.25rem;
}

.items-list {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.item-row {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e9ecef;
  background: white;
}

.item-row:last-child {
  border-bottom: none;
}

.item-info {
  display: flex;
  gap: 0.5rem;
}

.item-quantity {
  font-weight: 500;
  color: #495057;
}

.item-name {
  color: #6c757d;
}

.item-price {
  font-weight: 500;
}

.notes-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  font-style: italic;
  color: #495057;
}

.payment-details {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.payment-row.total-row {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #dee2e6;
  font-weight: 600;
}

.payment-label {
  color: #6c757d;
}

.payment-value {
  font-weight: 500;
}

.badge {
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .summary-card {
    grid-template-columns: 1fr;
  }
}
.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
  justify-content: space-between;
}

/* Search Section */
.search-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.search-container {
  position: relative;
}

.search-input-group {
  position: relative;
  display: flex;
  align-items: center;
}
/* Add to your style section */
.orders-list {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}

.order-item {
  transition: all 0.2s;
}


.order-items {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.search-input {
  padding: 0.75rem 1rem 0.75rem 3rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 1rem;
  transition: all 0.2s;
  background-color: #f8f9fa;
}

.search-input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  background-color: white;
}

.search-icon-btn {
  position: absolute;
  left: 1rem;
  background: none;
  border: none;
  color: #6c757d;
  z-index: 2;
}

.search-results {
  position: absolute;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 0.5rem;
}

.results-list {
  padding: 0.5rem 0;
}

.customer-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.customer-item:hover {
  background-color: #f8f9fa;
}

.customer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: #6c757d;
}

.customer-details {
  flex: 1;
}

.customer-name {
  font-weight: 500;
  color: #343a40;
  margin-bottom: 0.25rem;
}

.customer-meta {
  display: flex;
  font-size: 0.875rem;
  color: #6c757d;
}

.customer-phone {
  margin-right: 1rem;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-results svg {
  margin-bottom: 0.5rem;
  color: #adb5bd;
}

.divider {
  display: flex;
  align-items: center;
  color: #6c757d;
  margin: 1rem 0;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
}

.divider span {
  padding: 0 1rem;
}

.add-new-btn {
  color: var(--font-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 8px;
  font-weight: 500;
}

/* Address Section */
.address-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.customer-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.customer-avatar.large {
  width: 50px;
  height: 50px;
  margin-right: 1rem;
}

.customer-info h4 {
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.section-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
}

.address-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.address-item {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}

.address-item:hover {
  border-color: #adb5bd;
}
.gr{
      background-color: #28a745 !important;
}
.address-item.selected {
  border-color: #007bff;
  background-color: #f0f7ff;
}

.address-icon {
  margin-right: 1rem;
  color: #6c757d;
}

.address-content {
  flex: 1;
}

.address-title {
  font-weight: 500;
  color: #343a40;
  margin-bottom: 0.25rem;
}

.address-details {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.4;
}

.address-check {
  margin-left: 1rem;
  color: #007bff;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  margin-top: 1rem;
}

/* Buttons */
.btn {
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-btn {
  color: #6c757d;
}

.cancel-btn:hover {
  color: #495057;
  text-decoration: none;
}

.submit-btn {
  min-width: 150px;
}

.submit-btn:disabled {
  opacity: 0.65;
}

/* Animations */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>